import { render, staticRenderFns } from "./api-docs.vue?vue&type=template&id=254b4a06"
import script from "./api-docs.vue?vue&type=script&lang=js"
export * from "./api-docs.vue?vue&type=script&lang=js"
import style0 from "./api-docs.vue?vue&type=style&index=0&id=254b4a06&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports